import { createFileRoute } from "@tanstack/react-router"
import { RestorePassword } from "modules/auth/components/ResetPassword"
import { z } from "zod"

export const Route = createFileRoute("/_base/_public/reset-password")({
  component: RestorePassword,
  validateSearch: z.object({
    token: z.string(),
    activate: z.boolean().optional().default(false),
  }),
})
